/* Nordic Performance — cart drawer (v2) */
/* Kopierad från Kopia Nordic Performance assets/cart-drawer.js (döpt till np-cart-drawer.js) */
(function () {
  'use strict';
  var NP = window.NP || {};
  var threshold = NP.freeShipThreshold || 0; // cents

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || !window.fetch) return;

  var itemsEl    = drawer.querySelector('[data-cd-items]');
  var subtotalEl = drawer.querySelector('[data-cd-subtotal]');
  var footerEl   = drawer.querySelector('[data-cd-footer]');
  var emptyEl    = drawer.querySelector('[data-cd-empty]');
  var barEl      = drawer.querySelector('[data-cd-bar]');
  var barFill    = drawer.querySelector('[data-cd-bar-fill]');
  var barMsg     = drawer.querySelector('[data-cd-bar-msg]');

  function money(cents, currency) {
    var c = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(NP.locale || 'sv-SE', {
        style: 'currency', currency: currency || NP.currency || 'SEK'
      }).format(c);
    } catch (e) {
      return c.toFixed(2) + ' ' + (currency || NP.currency || '');
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }

  function open()  { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  function render(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('np-cart-badge--zero', cart.item_count === 0);
    });

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      if (barEl) barEl.hidden = true;
    } else {
      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;
      if (barEl) barEl.hidden = false;
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image
          ? '<img src="' + it.image + '" alt="" loading="lazy">'
          : '<span class="cd-noimg"></span>';
        var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1)
          ? '<span class="cd-variant">' + esc(it.variant_title) + '</span>' : '';
        return '<div class="cd-item" data-key="' + esc(it.key) + '">' +
            '<a class="cd-thumb" href="' + esc(it.url) + '">' + img + '</a>' +
            '<div class="cd-info">' +
              '<a class="cd-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
              '<div class="cd-row">' +
                '<div class="cd-qty">' +
                  '<button type="button" class="cd-qbtn" data-cd-dec aria-label="Minska antal">&minus;</button>' +
                  '<span class="cd-qval">' + it.quantity + '</span>' +
                  '<button type="button" class="cd-qbtn" data-cd-inc aria-label="Öka antal">+</button>' +
                '</div>' +
                '<span class="cd-price">' + money(it.final_line_price, cart.currency) + '</span>' +
              '</div>' +
              '<button type="button" class="cd-remove" data-cd-remove>Ta bort</button>' +
            '</div>' +
          '</div>';
      }).join('');
    }

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price, cart.currency);

    if (barEl && barFill && barMsg && threshold > 0) {
      var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      barFill.style.width = pct + '%';
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        barMsg.innerHTML = esc(NP.shipPre || 'Du är') + ' <b>' + money(remaining, cart.currency) + '</b> ' + esc(NP.shipPost || 'från fri frakt');
      } else {
        barMsg.textContent = NP.shipDone || 'Grattis – du har fri frakt!';
      }
    }
  }

  function getCart()  { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh()  { return getCart().then(render); }
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  // qty / remove (event delegation)
  itemsEl.addEventListener('click', function (e) {
    var item = e.target.closest('.cd-item'); if (!item) return;
    var key = item.getAttribute('data-key');
    var q = parseInt(item.querySelector('.cd-qval').textContent, 10) || 1;
    if (e.target.closest('[data-cd-inc]')) change(key, q + 1);
    else if (e.target.closest('[data-cd-dec]')) change(key, Math.max(0, q - 1));
    else if (e.target.closest('[data-cd-remove]')) change(key, 0);
  });

  // open / close
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open); });
  });
  drawer.querySelectorAll('[data-cd-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // intercept add-to-cart forms -> add via AJAX and open drawer
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { open(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
    });
  });

  refresh(); // sync count on load
})();
